export default __webpack_public_path__ + "static/media/msme.0f3eb7a3.png";